export const declineOption = [
  {
    name: "Price/No budget",
    value: "Price/No budget",
  },
  {
    name: "Conventional space",
    value: "Conventional space",
  },
  {
    name: "No Availability",
    value: "No Availability",
  },
  {
    name: "Product doesn't fit",
    value: "Product doesn't fit",
  },
  {
    name: "Competitor",
    value: "Competitor",
  },
  {
    name: "No Center in the preferred micro market",
    value: "No Center in the preferred micro market",
  },
  {
    name: "Others",
    value: "Others",
  },
];
